/**
 * Raised when a widget declaration cannot be turned into a widget.
 *
 * The message reaches the user through the error tile, so it is German and names what is wrong -
 * an unsupported widget type, an unknown schema, a row without an display type, a forbidden
 * operator or a runtime variable used where it does not resolve.
 */
export class UiHomeWidgetBuildError extends Error {

    constructor(message: string) {
        super(message);
        this.name = 'UiHomeWidgetBuildError';
    }
}
